module.exports = __webpack_public_path__ + "assets/8a5f0958af23230690983a8d369235bf.svg";